function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgLayer = function SvgLayer(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Layer' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M24.258,4 L0.022,16.118 L8.022,20.118 L0.022,24.118 L8.098,28.156 L0,32.107 L24.258,44.236 L48.455,32.138 L40.63,28.05 L48.494,24.118 L40.494,20.118 L48.494,16.118 L24.258,4 Z M4.494,16.118 L24.258,6.236 L44.022,16.118 L24.258,26 L4.494,16.118 Z M38.258,21.236 L44.022,24.118 L38.444,26.907 L38.408,26.889 L24.258,34 L4.494,24.118 L10.258,21.236 L24.258,28.236 L38.258,21.236 Z M38.424,29.153 L44.061,32.099 L24.258,42 L4.516,32.13 L10.351,29.283 L24.258,36.236 L38.424,29.153 Z"
  }));
};

SvgLayer = pure(SvgLayer);
SvgLayer.displayName = 'SvgLayer';
export default SvgLayer;